import { Input, Component, OnInit } from '@angular/core';
import { COMMON_CONSTANTS } from '../../constants/common-constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-brandlogo',
  templateUrl: './header-brandlogo.component.html',
  styleUrls: ['./header-brandlogo.component.css'],
})
export class HeaderBrandlogoComponent implements OnInit{

  CrossTabName: string = COMMON_CONSTANTS.CrossTabModuleName;
  BrandAnalysisName: string = COMMON_CONSTANTS.BrandAnalysisModuleName;
  ArkName: string = COMMON_CONSTANTS.ARKName;

  showStudyDropdown: boolean = false;
  @Input() studyListData: any;
  @Input() ImageURL: string;
  @Input() studyName:string="";
  @Input() clientName:string="";
  @Input() moduleName:string="";


  constructor(private router: Router,) {
    this.ImageURL = '';
  }
  ngOnInit() {
   
  }

  get hasMultipleStudies(): boolean {
    return this.configuredStudies.length > 1;
  }

  get shouldShowDropdown(): boolean {
    return this.hasMultipleStudies && this.isConfiguredModule();
  }

  get configuredStudies(): any[] {
    if (!this.studyListData || !this.isConfiguredModule()) {
      return [];
    }

    let studyArray = this.studyListData[0] || [];
    return studyArray.filter((study: any) => study.ModuleActive === true);
  }

  isConfiguredModule(): boolean {
    return this.moduleName === this.CrossTabName || this.moduleName === this.BrandAnalysisName;
  }

  studyDropdown() {
    // Only toggle dropdown if there are multiple studies and module is CrossTab or Brand Analysis
    if (this.shouldShowDropdown) {
      this.showStudyDropdown = !this.showStudyDropdown;
    }
  }


  navigateStudy(study: string) {
    this.showStudyDropdown = false;
    let data: { client_code: string; study: string; studyList: any } = {
      client_code: this.clientName,
      study: study,
      studyList: this.studyListData
    };
    switch (this.moduleName) {
      case this.CrossTabName:
        //this.router.navigateByUrl('Crosstab', { state: data });
        this.router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() => {
          this.router.navigateByUrl('/Crosstab', { state: data});
        });
        break;
      case this.BrandAnalysisName:
        this.router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() => {
          this.router.navigateByUrl('/BrandAnalysis', { state: data });
        });
        break;
      case this.ArkName:
        this.router.navigateByUrl('chatbotexpand', { state: data });
        break;
    }
  }
}
